module.exports = __webpack_public_path__ + "static/media/DSC_0308.5d2febee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0308.jpg
// module id = 663
// module chunks = 0